import React from 'react';
import { Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * Studio switcher button component that redirects users to the studios page
 * where they can view and select from all their available studios.
 */
interface StudioSwitcherProps {
  /** Optional CSS class name */
  className?: string;
}

const StudioSwitcher: React.FC<StudioSwitcherProps> = ({ className }) => {
  const navigate = useNavigate();

  const handleSwitchStudio = () => {
    navigate('/studios');
  };

  return (
    <Button
      onClick={handleSwitchStudio}
      className={className}
      sx={{
        textTransform: 'none',
        color: 'text.primary',
        '&:hover': {
          backgroundColor: 'action.hover',
        },
      }}
      aria-label="Switch studio"
    >
      <Typography variant="body2" sx={{ fontWeight: 500 }}>
        Switch Studio
      </Typography>
    </Button>
  );
};

export default StudioSwitcher;
